import React, { useEffect, useState } from 'react'
import { Col, Row, Table } from 'reactstrap'
import { apiHorariosService } from 'services/apiHorariosService'

const EmpleadoDetalleHorario = (props) => {

    const [jornadas, setJornadas] = useState([])


  

    const generateJornadaByDia = (dia) => {
        return (
            jornadas?.filter((jornada) => jornada.diaSem === dia).map((jornada) => (
                <>
                    <Row className='text-success'><Col style={{fontSize:16}} >{jornada.horaEntrada}</Col></Row>
                    <Row className='text-danger'><Col style={{fontSize:16}}>{jornada.horaSalida}</Col></Row>
                </>
            ))
        )
    }

    useEffect(() => {
        const fetchData = async () =>{
            const responseHorario = await apiHorariosService.getById(props.empleado?.horarioId)
            setJornadas(responseHorario?.jornadas)
    
    
        }
        fetchData()
        return () => {

        }
    }, [props.empleado])

  return (
    <>  
        <div className='mb-3'>
                <h3 className='mb-2'> Horario:</h3>
                <Table>
                    <thead>
                        <tr>
                            <th>Lunes</th>
                            <th>Martes</th>
                            <th>Miércoles</th>
                            <th>Jueves</th>
                            <th>Viernes</th>
                            <th>Sábado</th>
                            <th>Domingo</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr>
                            <td >
                                {generateJornadaByDia("L")}
                            </td>
                            <th>
                                {generateJornadaByDia("M")}
                            </th>
                            <th>
                                {generateJornadaByDia("X")}
                            </th>
                            <th>
                                {generateJornadaByDia("J")}
                            </th>
                            <th>
                                {generateJornadaByDia("V")}
                            </th>
                            <th>
                                {generateJornadaByDia("S")}
                            </th>
                            <th>
                                {generateJornadaByDia("D")}
                            </th>
                        </tr>
                    </tbody>
                </Table>

            </div>
    </>
  )
}

export default EmpleadoDetalleHorario